export default {
  SUCCESS: '9000',
  PROCESSING: '8000',
  FAILED: '4000',
  CANCELLED: '6001',
  NETWORK_ERROR: '6002',
  UNKNOWN: '6004', // Unknown result, might be a success
};
